import { IPublicMenuTheme } from "../../PublicMenu/Helpers/PublicMenuTheme"

export interface PublicMenuThemeDesign {
  publicMenuCardLayout: IPublicMenuTheme["cardLayout"]
  publicMenuPrimaryColor: string
  publicMenuSecondaryColor: string
  publicMenuAccentColor: string
  publicMenuBackgroundColor: string
  publicMenuSurfaceColor: string
  publicMenuTextColor: string
  publicMenuBorderColor: string
  publicMenuButtonColor: string
  publicMenuButtonTextColor: string
  publicMenuSearchBackgroundColor: string
  publicMenuSearchBorderColor: string
  publicMenuMobileNavBackgroundColor: string
  publicMenuMobileNavActiveBackgroundColor: string
  publicMenuMobileNavActiveTextColor: string
  publicMenuMobileNavActiveIconColor: string
  publicMenuMobileNavInactiveBackgroundColor: string
  publicMenuMobileNavInactiveTextColor: string
  publicMenuMobileNavInactiveIconColor: string
  publicMenuHeaderBackgroundColor: string
  publicMenuRestaurantNameColor: string
  publicMenuRestaurantDescriptionColor: string
  publicMenuStatusCardBackgroundColor: string
  publicMenuCartButtonColor: string
  publicMenuCartBackgroundColor: string
  publicMenuCartBorderColor: string
  publicMenuCartTitleTextColor: string
  publicMenuCartDescriptionTextColor: string
  publicMenuCartTotalLabelTextColor: string
  publicMenuCartTotalValueTextColor: string
  publicMenuEmptyStateTitleColor: string
  publicMenuEmptyStateDescriptionColor: string
  publicMenuCategoryBackgroundColor: string
  publicMenuCategoryBorderColor: string
  publicMenuCategoryDividerColor: string
  publicMenuLoginButtonBackgroundColor: string
  publicMenuLoginButtonTextColor: string
  publicMenuShareButtonBackgroundColor: string
  publicMenuShareButtonTextColor: string
  publicMenuServiceSelectorBackgroundColor: string
  publicMenuServiceSelectorTextColor: string
  publicMenuServiceSelectorActiveBackgroundColor: string
  publicMenuServiceSelectorActiveTextColor: string
  publicMenuBorderThickness: number
  publicMenuHighlightPromotions: boolean
  publicMenuCompactCategories: boolean
  publicMenuUseGradientHeader: boolean
  publicMenuShowAwardsTab: boolean
  publicMenuShowPromotionsTab: boolean
  publicMenuShowExtraServicesTab: boolean
}

export interface PublicMenuThemeEntity {
  id: number
  companyId: number
  name: string
  design: PublicMenuThemeDesign
  createdAt: string
  updatedAt: string
}

export const publicMenuThemeFromDesign = (design: PublicMenuThemeDesign): IPublicMenuTheme => ({
  cardLayout: design.publicMenuCardLayout as IPublicMenuTheme["cardLayout"],
  primaryColor: String(design.publicMenuPrimaryColor),
  secondaryColor: String(design.publicMenuSecondaryColor),
  accentColor: String(design.publicMenuAccentColor),
  backgroundColor: String(design.publicMenuBackgroundColor),
  surfaceColor: String(design.publicMenuSurfaceColor),
  textColor: String(design.publicMenuTextColor),
  borderColor: String(design.publicMenuBorderColor),
  buttonColor: String(design.publicMenuButtonColor),
  buttonTextColor: String(design.publicMenuButtonTextColor),
  searchBackgroundColor: String(design.publicMenuSearchBackgroundColor),
  searchBorderColor: String(design.publicMenuSearchBorderColor),
  mobileNavBackgroundColor: String(design.publicMenuMobileNavBackgroundColor),
  mobileNavActiveBackgroundColor: String(design.publicMenuMobileNavActiveBackgroundColor),
  mobileNavActiveTextColor: String(design.publicMenuMobileNavActiveTextColor),
  mobileNavActiveIconColor: String(design.publicMenuMobileNavActiveIconColor),
  mobileNavInactiveBackgroundColor: String(design.publicMenuMobileNavInactiveBackgroundColor),
  mobileNavInactiveTextColor: String(design.publicMenuMobileNavInactiveTextColor),
  mobileNavInactiveIconColor: String(design.publicMenuMobileNavInactiveIconColor),
  headerBackgroundColor: String(design.publicMenuHeaderBackgroundColor),
  storeNameColor: String(design.publicMenuRestaurantNameColor),
  storeDescriptionColor: String(design.publicMenuRestaurantDescriptionColor),
  statusCardBackgroundColor: String(design.publicMenuStatusCardBackgroundColor),
  cartButtonColor: String(design.publicMenuCartButtonColor),
  cartBackgroundColor: String(design.publicMenuCartBackgroundColor),
  cartBorderColor: String(design.publicMenuCartBorderColor),
  cartTitleTextColor: String(design.publicMenuCartTitleTextColor),
  cartDescriptionTextColor: String(design.publicMenuCartDescriptionTextColor),
  cartTotalLabelTextColor: String(design.publicMenuCartTotalLabelTextColor),
  cartTotalValueTextColor: String(design.publicMenuCartTotalValueTextColor),
  emptyStateTitleColor: String(design.publicMenuEmptyStateTitleColor),
  emptyStateDescriptionColor: String(design.publicMenuEmptyStateDescriptionColor),
  categoryBackgroundColor: String(design.publicMenuCategoryBackgroundColor),
  categoryBorderColor: String(design.publicMenuCategoryBorderColor),
  categoryDividerColor: String(design.publicMenuCategoryDividerColor),
  loginButtonBackgroundColor: String(design.publicMenuLoginButtonBackgroundColor),
  loginButtonTextColor: String(design.publicMenuLoginButtonTextColor),
  shareButtonBackgroundColor: String(design.publicMenuShareButtonBackgroundColor),
  shareButtonTextColor: String(design.publicMenuShareButtonTextColor),
  serviceSelectorBackgroundColor: String(design.publicMenuServiceSelectorBackgroundColor),
  serviceSelectorTextColor: String(design.publicMenuServiceSelectorTextColor),
  serviceSelectorActiveBackgroundColor: String(design.publicMenuServiceSelectorActiveBackgroundColor),
  serviceSelectorActiveTextColor: String(design.publicMenuServiceSelectorActiveTextColor),
  borderThickness: Number(design.publicMenuBorderThickness),
  highlightPromotions: Boolean(design.publicMenuHighlightPromotions),
  compactCategories: Boolean(design.publicMenuCompactCategories),
  useGradientHeader: Boolean(design.publicMenuUseGradientHeader),
})
